import React from 'react';
import styled from 'styled-components';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { canLogEvents } from '@/utils/canLogEvents';
import { generateDownloadLink } from '@/utils/generateDownloadLink';

const fireAmplitude = (storeType: string) => {
  if (canLogEvents()) {
    amplitudeModule.logEvent('download_click', {
      type: storeType,
    });
  }
};

const DownloadLinksStyles = styled.div`
  margin: 12px 0;
  display: flex;
  justify-content: space-around;
  gap: 12px;

  a {
    display: block;
    aspect-ratio: 1 / 0.29;
    width: 166px;
    font-size: 0;
    line-height: 0;

    @media screen and (min-width: 576px) {
      width: 168px;
    }

    img {
      height: 100%;
      width: 100%;
    }
  }
`;

export const DownloadLinks: React.FC = () => {
  const { user } = useAccount();

  const downloadingAppLink = React.useMemo(() => {
    return generateDownloadLink(user?.id || '');
  }, [user?.id]);

  return (
    <DownloadLinksStyles>
      <a href={downloadingAppLink} onClick={() => fireAmplitude('appstore')}>
        <img
          src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/appstore.png"
          alt="appstore"
        />
      </a>
      <a href={downloadingAppLink} onClick={() => fireAmplitude('googleplay')}>
        <img
          src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/googleplay.png"
          alt="googleplay"
        />
      </a>
    </DownloadLinksStyles>
  );
};
